import relatedBlogs from '../components/relatedBlogs'
import articleFeaturedProducts from '../components/articleFeaturedProducts'

const article = {
  renderBreadcrumbs() {
    let blogReferrer = localStorage.getItem('blogReferrer');
    if (blogReferrer) {
      blogReferrer = JSON.parse(blogReferrer);
      document.querySelector('.article__breadcrumbs--filterLink').setAttribute('href', blogReferrer.url);
      document.querySelector('.article__breadcrumbs--filterLink').innerHTML = blogReferrer.title;
      document.querySelector('.article__breadcrumbs--filter').classList.remove('hidden');

      localStorage.removeItem('blogReferrer');
    }
  },

  init() {
    if(document.getElementById('articleTemplate')) {
      articleFeaturedProducts.init();
      this.renderBreadcrumbs();
      relatedBlogs.init();
    }
  }
}

export default article